jQuery(document).ready(function ($) {

    class Duku {
        ajax(formData, formId, formMessageId) {
            var ajaxForm = new AjaxForm(formData);
            ajaxForm.messageElement = $(formMessageId);
            ajaxForm.formElement = $(formId);
            ajaxForm.call(function (data) {
                if (data.success){
                    location.reload();
                }
            });
        }

        init() {
            this.formSubmissions();
            this.removeUser();
            this.removeProgressCourse();
            this.changePassword();
        }

        formSubmit(formId, formMessageId, submissionMessage = "creating ...") {
            var _this = this;
            $(formId).on("submit", function (e) {
                e.preventDefault();
                $(formMessageId).text(submissionMessage);
                var formData = new FormData(this);
                //_this.errorLogFormEntries(formData);
                _this.ajax(formData, formId, formMessageId);
            });
        }

        formSubmissions() {
            this.formSubmit("#createClassForm", "#createClassFormMessage", "creating class ...");
            this.formSubmit("#addUserForm", "#addUserModalMessage", "creating user ...");
            this.formSubmit("#removeUserForm", "#removeUserModalMessage", "removing user ...");
            this.formSubmit("#changePasswordForm", "#changePasswordModalMessage", "changing password ...");
            this.formSubmit("#addSchoolForm", "#addSchoolModalMessage", "adding school ...");
            this.formSubmit("#addProgressCourseForm", "#addProgressCourseFormMessage", "adding course ...");
            this.teacherUpdate();
        }

        removeProgressCourse() {
            $(".course-remove").on("click", function(){

                var formData = new FormData();
                formData.append("action", "removeProgressCourse");
                formData.append("course_id", $(this).data("courseid"));
                formData.append("school_id", $(this).data("schoolid"));
                formData.append("classroom_id", $(this).data("classroomid"));
                formData.append("newcourseid", $(this).data("newcourseid"))
                
                var ajaxForm = new AjaxForm(formData);
                ajaxForm.call(function (data) {
                    location.reload();
                });
            });
        }

        teacherUpdate() {
            var _this = this;
            $(".updateTeacherForm").on("change", function () {
                var formData = new FormData(this);
                _this.errorLogFormEntries(formData);
                _this.ajax(formData, ".updateTeacherForm", "");
            });
        }

        removeUser() {
            $(".user-remove").on("click", function () {
                $("#removeUserName").text($(this).attr("data-userlogin"));
                $("#removeFormUserId").val($(this).attr("data-userid"));
            });
        }

        changePassword() {
            $(".user-pass").on("click", function () {
                $("#changePasswordUserName").text($(this).attr("data-userlogin"));
                $("#changePasswordUserId").val($(this).attr("data-userid"));
            });
        }

        errorLogFormEntries(formData) {
            for (var pair of formData.entries()) {
                console.log(pair[0] + ', ' + pair[1]);
            }
        }
    }

    var duku = new Duku();
    duku.init();


});